// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"022bddc6","261":"3cdae07a","384":"bcbcdb48","606":"53fcc662","785":"3c26e694","942":"4faad713","960":"5bde81c2"}[chunkId] + ".chunk.js";
};